import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One lesson card covers one class — then it’s back to the blank page', 'Moves and games, but you still build every session yourself', 'No easier lane for the student who can’t do it yet', 'Nothing for the queue — kids wait, then act up', 'Assumes a gym full of equipment you may not have'];
const withIt = ['59 complete sessions, each in the same four blocks', 'A progression from first landings to full flow lines', 'A built-in regression in every skill block', 'A game in every class to burn energy and cover waiting time', 'No-gear variants and big-group station plans'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-navy" data-id="element-255" data-mp="2d80xkzfmk0lj">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-256" data-mp="30yn24gqf72qs">
        <div className="text-center" data-id="element-257" data-mp="30x3mmscl8vq2">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-258" data-mp="35ov3uc9utp3j">
            Why this isn&apos;t another drill list
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-259" data-mp="1tfmocq8uvt3z">
            A folder of ideas vs{' '}
            <span className="text-gold" data-id="element-260" data-mp="235y3za1wjqqp">a class that&apos;s ready to run</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-261" data-mp="1ydo5v6qmvkdc">
            Today it&apos;s either single lesson cards that cover one class, or
            school programs that cost thousands and ship with an equipment kit.
            Neither gives an individual coach a full year of classes, ready to
            run, at a price that makes sense.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-navy-line" data-id="element-262" data-mp="2h34mr4mmlpfx">
          <div className="bg-navy-mid px-3.5 py-4 sm:p-6" data-id="element-263" data-mp="rru8u0jkvwk2">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-264" data-mp="ms7v7pzu8eaq">
              Drill lists &amp; lesson cards
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-265" data-mp="2rrqtur2c8ogg">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-266" data-mp="2vu3y1b1fseb4">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-267" data-mp="30quhm8cg9s1a">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-268" data-mp="3aqv1pwi58c6j" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-gold/10 px-3.5 py-4 text-white sm:p-6" data-id="element-269" data-mp="3jjybnutky6wf">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-270" data-mp="3jl9ffun0zenj">
              Parkour Class-Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-271" data-mp="3tinvht51e1fb">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-272" data-mp="7gf65jf0zrz1">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-teal/20" data-id="element-273" data-mp="3tndewfaeatge">
                    <CheckIcon className="h-2.5 w-2.5 text-teal-soft" aria-hidden="true" data-id="element-274" data-mp="3pm9xhocp8pd2" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}